import { FormLabel } from '@components/shared/form-label.component';
import { PopoverSelector } from '@components/shared/popover-selector.component';
import { countries } from '@utils/constants';
import { FunctionComponent, useMemo } from 'react';
import { ErrorMessage } from './error-message.component';
import { FormField } from './form-field.component';

interface CountrySelectorProps {
  value: string | null | undefined;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  name?: string;
  disabled?: boolean;
  label?: string;
  isRequired?: boolean;
  placeholder?: string;
  className?: string;
  triggerClassName?: string;
  contentClassName?: string;
  error?: string;
}

export const CountrySelector: FunctionComponent<CountrySelectorProps> = (props) => {
  const {
    value,
    onChange,
    name = 'country',
    disabled = false,
    label,
    isRequired = false,
    placeholder = 'Select country',
    className,
    triggerClassName,
    contentClassName,
    error,
  } = props;

  const countryOptions = useMemo(() => {
    return countries.map((country) => ({ value: country.code, label: `${country.name} (${country.code})` }));
  }, []);

  return (
    <FormField className={className}>
      {label && (
        <FormLabel
          className="mb-1"
          isRequired={isRequired}
          label={label}
        />
      )}
      <PopoverSelector
        contentClassName={contentClassName}
        disabled={disabled}
        emptyMessage="No country found"
        hasError={!!error}
        name={name}
        onChange={onChange}
        options={countryOptions}
        placeholder={placeholder}
        searchPlaceholder="Search country..."
        triggerClassName={triggerClassName}
        value={value}
      />
      <ErrorMessage message={error} />
    </FormField>
  );
};
